/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'dialog';
const componentName = 'avi-suppress-warnings-dialog';
const prefix = `${moduleName}.${componentName}`;

export const headerMessage = `${prefix}.headerMessage`;
export const subHeaderMessage = `${prefix}.subHeaderMessage`;
export const suppressWarningsLabel = `${prefix}.suppressWarningsLabel`;
export const footerMessage = `${prefix}.footerMessage`;
export const configurationWarningslocationLabel = `${prefix}.configurationWarningslocationLabel`;
export const continueBtnLabel = `${prefix}.continueBtnLabel`;

export const ENGLISH = {
    [headerMessage]: 'Configuration Warning',
    [subHeaderMessage]: 'The following warnings came up when saving. If you would like to continue you can suppress the warnings',
    [suppressWarningsLabel]: 'Suppress all warnings and continue',
    [footerMessage]: 'If you want to turn off this feature ({0})',
    [configurationWarningslocationLabel]: "<span class='avi-suppress-warnings-dialog__location'>My Account → Controller → 'Configuration Warnings'</span>",
    [continueBtnLabel]: 'Continue',
};
